export default "__VITE_ASSET__DRAjGEIn__"